import { IMForm, IMInputText, IMSubmitButton } from '@insurancemenu/imenu-components-lib';
import styled from 'styled-components';

export const DiscountFormStyled = styled(IMForm)`
  display: flex;
  flex-direction: row;
  align-items: flex-start;
  gap: 3rem;
  padding: 0;
`;

export const IMInputTextStyled = styled(IMInputText)`
  flex: none;
  width: unset;
`;

export const IMSubmitButtonStyled = styled(IMSubmitButton)`
  margin-top: 2.8rem;
`;
